import React from 'react';

import { CLEARVERIFY_LOGO, CLEARVERIFY_LOGO_SM } from 'src/assets';

export const LeftMenuLogo: React.FC<{ showIcon?: boolean }> = ({ showIcon = false }) => {
  return (
    <img
      style={{ width: !showIcon ? '100%' : 'auto' }}
      alt="Clear Verify"
      src={!showIcon ? CLEARVERIFY_LOGO : CLEARVERIFY_LOGO_SM}
    />
  );
};
